import React, { Fragment } from "react";
import Tooltip from "../tooltip";
import styles from "./style.module.css";

export default function InputWithTooltip(props) {
  const { value, required, label, id, name, options, placeholder, onChange } =
    props;
  const {
    tooltipText,
    position,
    transform,
    customClass,
    type,
    minimum,
  } = options;
  return (
    <Fragment>
      <label className="control-label" htmlFor={id}>
        <b>{label}</b>
        {required && <span className="required">*</span>}
        <Tooltip
          content={tooltipText}
          position={position}
          transform={transform}
          customClass={`${customClass} ${styles.tooltip_icon}`}
        />
      </label>
      <input
        type={type || "text"}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        placeholder={placeholder}
        name={name}
        className={"form-control"}
        id={id}
        label={label}
        min={minimum}
      />
    </Fragment>
  );
}
